import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { DrawerType, VerticalTransition } from "../../constants";
import { useClickOutside, useNoScroll } from "../../hooks";
import SettingsActionCreators from "../../redux/action-creators/settingsActionCreators";
import { SettingsSelectors } from "../../redux/selectors";
import userContextSelectors from "../../redux/selectors/userContextSelectors";
import { TrackingUtils } from "../../utils";
import { SettingsDrawerArea } from "../Settings";
import { SettingsDrawerHeader } from "../Settings/components";
import GenericDrawer from "./GenericDrawer";

const SettingsDrawer = () => {
  const isDrawerActive = useSelector(SettingsSelectors.general.isDrawerActive);
  const isDrawerLoaded = useSelector(SettingsSelectors.general.isDrawerLoaded);
  const isMobile = useSelector(userContextSelectors.isMobile);

  const dispatch = useDispatch();

  const drawerRef = useClickOutside(
    () => {
      TrackingUtils.sendAnalytics({
        dataCategory: "client overlay",
        dataAction: "click",
        dataLabel: `uc-settings-${isMobile ? "mobile" : "pc"}-close`
      });

      dispatch(SettingsActionCreators.general.toggleDrawer());
    },
    {
      disabled: !isDrawerActive,
      ignoreClass: ["debug-action-button", "ignore-uc-settings-pc"] //to do
    }
  );

  useNoScroll("settingsDrawer", isDrawerActive);

  return (
    <GenericDrawer
      componentRef={drawerRef}
      menu={DrawerType.SettingsArea}
      header={<SettingsDrawerHeader />}
      className="settings-drawer"
      isVisible={isDrawerActive && isDrawerLoaded}
      verticalTransition={
        isMobile ? VerticalTransition.Left : VerticalTransition.Right
      }
    >
      <SettingsDrawerArea />
    </GenericDrawer>
  );
};

export default React.memo(SettingsDrawer);
